import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import { BUSINESS_EMAIL_THREAD } from "../Business.constants";

const BusinessEmailThread = Loadable(
  lazy(() =>
    import("./BusinessEmailThread").then(({ BusinessEmailThread }) => ({
      default: BusinessEmailThread,
    }))
  )
);

export const EmailThreadRoutes = [
  {
    path: `${BUSINESS_EMAIL_THREAD}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessEmailThread />
      </AuthorizedRoute>
    ),
  },
];
